/**
 * What the footer's Continue says on the steps where it confirms or approves: why it cannot yet,
 * beside the disabled button, and what it reads while the write is out. One module, so the product
 * copy is one file to change.
 */

/** While the write Continue makes is out on Materials. */
export const CONFIRMING_LABEL = 'Confirming…';
/** While the approval Continue makes is out on Questions, Guide and Audience. */
export const APPROVING_LABEL = 'Approving…';

/** Materials: the intake differs from what is saved, and Continue confirms only what is saved. */
export const MATERIALS_UNSAVED_HINT = 'Save your changes first.';
/** Materials: a row's edit is open. */
export const MATERIALS_EDIT_OPEN_HINT = 'Finish the edit you have open.';
/** Materials: the reading of what is saved has not settled. */
export const MATERIALS_READING_HINT = 'Sigora is still reading your materials.';
/** Materials: a fact the Study Type needs is missing. */
export const MATERIALS_MISSING_HINT = 'Fill in the facts Sigora needs.';
/** Materials: nothing is saved for the study's type as it is now. */
export const MATERIALS_NOTHING_SAVED_HINT = 'Save your materials for this study type first.';
/** Materials: a file is still on its way up. */
export const MATERIALS_UPLOADING_HINT = 'Sigora is still uploading your file.';
/** Materials: a save or a fix waits on the reader's answer to what it would change below. */
export const MATERIALS_CHANGE_PENDING_HINT = 'Answer the question above first.';
/** Materials: the server will not take a confirmation for a reason none of the above names. */
export const MATERIALS_NOT_CONFIRMABLE_HINT = 'Sigora cannot confirm these materials yet.';

/** A document step: an edit of its wording is open. */
export const EDITS_OPEN_HINT = 'Save or cancel the wording you are changing.';
/** A document step: a write of its own is out, or the read after one has not landed. */
export const SAVING_HINT = 'Sigora is saving your change.';

/** Questions, none drafted yet: the study has no chosen Goal to draft them from. */
export const QUESTIONS_NEED_GOAL_HINT = 'Choose your goal first.';
/** Questions, none drafted yet: the first draft is asked for or out. */
export const QUESTIONS_DRAFTING_HINT = 'Sigora is drafting your questions.';
/** Questions, none drafted yet: the first draft failed or ran late, and "Try again" is offered. */
export const QUESTIONS_DRAFT_FAILED_HINT =
  'Sigora could not draft your questions. Try again above.';
/** Guide: the research questions are not approved, so no guide can be drafted or approved. */
export const RQS_NOT_APPROVED = 'Approve your research questions first.';
/** Guide, none drafted yet: the first draft is asked for or out. */
export const GUIDE_DRAFTING_HINT = 'Sigora is drafting your guide.';
/** Guide, none drafted yet: the first draft failed or ran late, and "Try again" is offered. */
export const GUIDE_DRAFT_FAILED_HINT = 'Sigora could not draft your guide. Try again above.';
/** Audience, none drafted yet: the guide is approved and the first audience is on its way. */
export const AUDIENCE_DRAFTING_HINT = 'Sigora is drafting your audience.';
/**
 * Audience, none drafted yet: the wait for the first audience ran out with none written. Nothing on
 * the step can ask again, and the step's conversation can draft it.
 */
export const AUDIENCE_DRAFT_FAILED_HINT =
  'Sigora has not drafted your audience. Ask Sigora below to draft it.';

/** Questions: being drafted again, or updated for a change above them. */
export const QUESTIONS_UPDATING_HINT = 'Sigora is updating these questions.';
/** Guide: being drafted again, or updated for a change above it. */
export const GUIDE_UPDATING_HINT = 'Sigora is updating this guide.';
/** Audience: being updated for a change above it. */
export const AUDIENCE_UPDATING_HINT = 'Sigora is updating this audience.';

/** Questions: their redraft or update failed or ran late, and "Try again" is offered above. */
export const QUESTIONS_RETRY_HINT = 'Sigora could not update these questions. Try again above.';
/** Guide: its redraft or update failed or ran late, and "Try again" is offered above. */
export const GUIDE_RETRY_HINT = 'Sigora could not update this guide. Try again above.';
/** Audience: its update failed or ran late, and "Try again" is offered above. */
export const AUDIENCE_RETRY_HINT = 'Sigora could not update this audience. Try again above.';
/** Guide: a redraft was just asked for. */
export const GUIDE_REDRAFTING_HINT = 'Sigora is redrafting this guide.';

/** Guide: the coverage check of the guide on screen has not answered. */
export const GUIDE_CHECKING_HINT = 'Sigora is checking the guide covers your questions.';
/** Guide: the coverage check could not be made. */
export const GUIDE_CHECK_FAILED_HINT = 'Sigora could not check the guide. Try the check again.';
/** Guide: the coverage check found a research question nothing in the guide answers. */
export const GUIDE_GAP_HINT = 'Fix the gaps above, or redraft the guide.';
/** Guide: the check is unsure of some questions; Continue approves anyway. */
export const GUIDE_APPROVE_ANYWAY_LABEL = 'Approve anyway and continue';
